<!-- File: IoT-User-Frontend/src/views/About.vue -->
<template>
    <div>
        <Breadcrumb mainTitle="About Us"
            breadContent="The ASDL IoT Team consists of researchers and students working on cutting-edge sensor networks for smart campus initiatives. Our team is dedicated to developing innovative, reliable, and low-cost IoT solutions for real-time monitoring and analytics."
            subTitle="About Us" />

        <!-- About Area -->
        <div class="about-area section-padding">
            <div class="container">
                <div class="row">
                    <!-- Left Column: Text Content -->
                    <div class="col-lg-6 wow fadeInLeft" data-wow-delay=".3s">
                        <div class="about-content-wrap">
                            <div class="section-title">
                                <h6>About Us</h6>
                                <h2 class="text-secondary">Who We Are</h2>
                            </div>
                            <div class="about-content">
                                <p class="highlight">
                                    The Aerospace Systems Design Laboratory (ASDL) IoT initiative focuses on integrating
                                    smart technology solutions for data-driven decision-making in built environments.
                                    Our team works on IoT-enabled sensing, data analytics, and visualization to
                                    enhance sustainability and efficiency.
                                </p>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="about-content-inner">
                                            <h5>Mission</h5>
                                            <p>
                                                To advance IoT research and implementation for intelligent
                                                infrastructure and smart cities.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="about-content-inner">
                                            <h5>Vision</h5>
                                            <p>
                                                To pioneer next-generation IoT solutions for sustainable
                                                and data-driven decision-making.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Right Column: Image -->
                    <div class="col-lg-6 wow fadeInRight" data-wow-delay=".3s">
                        <div class="about-img text-end">
                            <img src="/assets/img/about/asdl-iot.jpg" alt="About Us" class="img-fluid rounded-3" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Team Area -->
        <div class="team-area gray-bg section-padding">
            <div class="container">
                <div class="row justify-content-center mb-4">
                    <div class="col-lg-12">
                        <div class="section-title text-center">
                            <h6>Our Team</h6>
                            <h2 class="text-secondary">Meet Our Experts</h2>
                        </div>
                    </div>
                </div>

                <!-- Dynamically render team cards -->
                <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
                    <div class="col" v-for="(member, index) in teamMembers" :key="index">
                        <div class="card shadow border-0 h-100 text-center">
                            <img :src="member.image" class="card-img-top" :alt="member.name"
                                style="object-fit: contain; max-height: 300px;" />
                            <div class="card-body">
                                <h5 class="card-title">
                                    <a :href="member.profileLink" target="_blank" style="text-decoration: none;">
                                        {{ member.name }}
                                    </a>
                                </h5>
                                <p class="card-text">{{ member.title }}</p>
                                <p><b>Phone:</b> {{ member.phone }}</p>
                                <p>
                                    <b>Email: </b>
                                    <a :href="'mailto:' + member.email">{{ member.email }}</a>
                                </p>
                                <p><b>Office:</b> {{ member.office }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Expertise section -->
        <div class="expertise-section dark-bg">
            <div class="row">
                <div class="col-lg-6">
                    <div class="expertise-content">
                        <div class="section-title">
                            <h6>Our Expertise</h6>
                            <h2 class="text-secondary">Advancing IoT for a Smarter Campus</h2>
                        </div>
                        <p class="text-white">
                            The ASDL IoT Team specializes in the development and deployment of sensor networks to
                            monitor
                            air quality, energy consumption, and building occupancy. Our goal is to create sustainable,
                            efficient, and intelligent infrastructure solutions.
                        </p>
                        <div class="progress-bar-area">
                            <div class="single-bar-item">
                                <h6 class="text-white">IoT Development</h6>
                                <div id="bar1" class="barfiller">
                                    <span class="tip">90%</span>
                                    <span class="fill" data-percentage="90"></span>
                                </div>
                            </div>

                            <div class="single-bar-item">
                                <h6 class="text-white">Data Analytics</h6>
                                <div id="bar2" class="barfiller">
                                    <span class="tip">85%</span>
                                    <span class="fill" data-percentage="85"></span>
                                </div>
                            </div>

                            <div class="single-bar-item">
                                <h6 class="text-white">Energy Monitoring</h6>
                                <div id="bar3" class="barfiller">
                                    <span class="tip">80%</span>
                                    <span class="fill" data-percentage="80"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="expertise-img"></div>
                    <div class="subscribed-wrap">
                        <div class="subscribe-form">
                            <h3>Join our community</h3>
                            <form action="index.html">
                                <input type="email" placeholder="Your email">
                                <button type="submit"><i class="las la-envelope"></i></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Breadcrumb from '@/components/Breadcrumb.vue';

export default {
    name: 'About',
    components: { Breadcrumb },
    data() {
        return {
            teamMembers: []
        };
    },
    async mounted() {
        // Scroll to top.
        window.scrollTo(0, 0);

        $("#bar1").barfiller({
            barColor: "#007CFF",
            duration: 5000,
        });

        $("#bar2").barfiller({
            barColor: "#007CFF",
            duration: 5000,
        });

        $("#bar3").barfiller({
            barColor: "#007CFF",
            duration: 5000,
        });

        // Load team-member data via Axios
        try {
            const response = await axios.get('/assets/data/teamMembers.json');
            this.teamMembers = response.data; // if the JSON is an array, just store response.data
        } catch (error) {
            console.error('Error loading Team Members data:', error);
        }
    }
};
</script>

<style scoped>
.section-title h2[data-v-039c5b43] {
    font-size: 55px;
    font-weight: 600;
    line-height: 65px;
    margin: 20px 0;
    color: #7b809a !important;
}

.section-padding {
    padding: 60px 0;
}

.gray-bg {
    background-color: #f9f9f9;
}

.about-content-wrap {
    margin-bottom: 30px;
}

.highlight {
    font-weight: 500;
}

.about-content h5 {
    margin-top: 15px;
    margin-bottom: 5px;
}

/* Card hover link color */
.card a:hover {
    color: #f35c27;
}
</style>